import { render, staticRenderFns } from "./GameConfigDialog.vue?vue&type=template&id=74b1339b&scoped=true&"
import script from "./GameConfigDialog.vue?vue&type=script&lang=js&"
export * from "./GameConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b1339b",
  null
  
)

export default component.exports